module.exports = __webpack_public_path__ + "static/img/Adam-Taggart.98090fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-Taggart.jpg
// module id = TUoC
// module chunks = 0